const t = (n) => {
  const e = String(n);
  return e === "true" || e === "undefined";
};
export {
  t as d
};
//# sourceMappingURL=defined-by-default.11c0fbdd.js.map
